import React, { useState, useEffect } from "react";

import "./DrawingCanvasDemo.css";

const CYCLE_DURATION_MS = 6000;
const COLORS = [
    { name: "blue", value: "#229adb" },
    { name: "red", value: "#e85a5a" },
    { name: "green", value: "#1f8a3a" },
];

const DrawingCanvasDemo = () => {
    const [cycle, setCycle] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCycle((c) => c + 1);
        }, CYCLE_DURATION_MS);
        return () => clearTimeout(timeout);
    }, [cycle]);

    const activeColor = COLORS[cycle % COLORS.length];

    return (
        <div className="drawing-canvas-demo" aria-hidden="true">
            <div className="canvas-header">
                <div className="canvas-tools">
                    {COLORS.map((c) => (
                        <span
                            key={c.name}
                            className={
                                "tool-dot tool-" +
                                c.name +
                                (c.name === activeColor.name ? " is-active" : "")
                            }
                            style={{ backgroundColor: c.value }}
                        />
                    ))}
                </div>
                <span className="canvas-title">Sketch Board</span>
                <span className="canvas-pen-icon">🖊️</span>
            </div>
            <div className="canvas-body">
                <svg
                    viewBox="0 0 320 200"
                    className="canvas-svg"
                    key={cycle}
                    style={{ "--ink-color": activeColor.value }}
                >
                    <line x1="20" y1="160" x2="300" y2="160" stroke="#dde2e9" strokeWidth="1.5" />
                    <line x1="160" y1="20" x2="160" y2="180" stroke="#dde2e9" strokeWidth="1.5" />

                    <polygon
                        points="300,160 294,156 294,164"
                        fill="#dde2e9"
                    />
                    <polygon
                        points="160,20 156,26 164,26"
                        fill="#dde2e9"
                    />

                    <path
                        className="canvas-path"
                        d="M40,158 Q160,-30 280,158"
                        stroke={activeColor.value}
                        strokeWidth="3"
                        fill="none"
                        strokeLinecap="round"
                    />

                    <text
                        x="200"
                        y="55"
                        className="canvas-formula"
                        fill={activeColor.value}
                    >
                        y = x²
                    </text>
                </svg>
            </div>
        </div>
    );
};

export default DrawingCanvasDemo;
